import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-300">404</h1>
        <h2 className="text-3xl font-semibold text-gray-700 mt-4">
            Die angeforderte Seite wurde nicht gefunden.
        </h2>
        <div className="space-x-4">
            <a href="/" className="mt-6 inline-block px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
                Zum Dashboard
            </a>

        </div>
      </div>
    </div>
  );
}

export default NotFound;
